//For Base URL and User Authentication
const BASE_URL = "https://api.automa.id/api";

const TRANSPORTER_URL = BASE_URL + "/transporter";
const REPORT_BASE_URL = TRANSPORTER_URL + "/report";
const TRANSPORTER_SHARE_TRACK_URL = REPORT_BASE_URL + "/check/in/log/share";
const TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS_URL =
  BASE_URL + "/delivery/work/customer/view";
const TRANSPORTER_DELIVERY_CONFIRMATION_APPROVE_URL =
  BASE_URL + "/delivery/customer/approve";

const DELIVERY_BASE_URL = BASE_URL + "/delivery";
const DELIVERY_STATUS_LIST_URL = DELIVERY_BASE_URL + "/status/list";

const WORK_ORDER_UPLOADED_IMAGE_LIST_URL =
  DELIVERY_BASE_URL + "/work/list/v2/image";
const WORK_ORDER_UPLOAD_IMAGE_URL = DELIVERY_BASE_URL + "/work/input/v2/image";
const WORK_ORDER_UPLOADED_IMAGE_DELETE_URL =
  DELIVERY_BASE_URL + "/work/list/v2/image/delete";
const WORK_ORDER_LIST_FOR_PROOF = DELIVERY_BASE_URL + "/work/driver/list";
const WORK_ORDER_STOCKER_OUTBOUND_ITEM =
  DELIVERY_BASE_URL + "/work/list/outbound";
const WORK_ORDER_STOCKER_INBOUND_ITEM =
  DELIVERY_BASE_URL + "/work/list/inbound";

const USER_URL = BASE_URL + "/user";
const COMPANY_SETTING_LIST_URL = USER_URL + "/company/list";

const STOCKER_BASE_URL = "https://api.automa.id/api/stocker";
const MASTER_OUTBOUND_LIST_URL = STOCKER_BASE_URL + "/outbound/list";
const OUTBOUND_ITEM_DETAIL_LIST_URL =
  STOCKER_BASE_URL + "/outbound/item/detail/list";

const LIVE_MONITORING_URL = REPORT_BASE_URL + "/live/share";
const SETTING_LIST_URL = USER_URL + "/settinglist";

const OPNAME_LIST = BASE_URL + "/stocker/opname/list";
const OPNAME_EDIT = BASE_URL + "/stocker/opname/edit";
const OPNAME_ORDER_DETAIL_LIST =
  BASE_URL + "/stocker/opname/task-order-detail/list";
const OPNAME_ORDER_DETAIL_EDIT =
  BASE_URL + "/stocker/opname/task-order-detail/edit";

const WAREHOUSE_LIST_URL = BASE_URL + "/stocker/warehouse/list";
const WAREHOUSE_AREAS_LIST_URL = BASE_URL + "/stocker/warehouse/area/list";
const WAREHOUSE_RACK_LIST_URL = BASE_URL + "/stocker/warehouse/rack/list";

const  TRACK_AND_TRACE_SHARE_URL = REPORT_BASE_URL + "/audit/track/trace";

export {
  TRANSPORTER_SHARE_TRACK_URL,
  TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS_URL,
  TRANSPORTER_DELIVERY_CONFIRMATION_APPROVE_URL,
  DELIVERY_STATUS_LIST_URL,
  WORK_ORDER_UPLOADED_IMAGE_LIST_URL,
  WORK_ORDER_UPLOAD_IMAGE_URL,
  WORK_ORDER_UPLOADED_IMAGE_DELETE_URL,
  WORK_ORDER_LIST_FOR_PROOF,
  WORK_ORDER_STOCKER_OUTBOUND_ITEM,
  WORK_ORDER_STOCKER_INBOUND_ITEM,
  COMPANY_SETTING_LIST_URL,
  SETTING_LIST_URL,
  MASTER_OUTBOUND_LIST_URL,
  OUTBOUND_ITEM_DETAIL_LIST_URL,
  LIVE_MONITORING_URL,
  OPNAME_LIST,
  OPNAME_EDIT,
  OPNAME_ORDER_DETAIL_LIST,
  OPNAME_ORDER_DETAIL_EDIT,
  WAREHOUSE_LIST_URL,
  WAREHOUSE_AREAS_LIST_URL,
  WAREHOUSE_RACK_LIST_URL,
  TRACK_AND_TRACE_SHARE_URL
};



// WEBPACK FOOTER //
// ./src/redux/config/links.jsx